// Passive Events Patch for jQuery/Slick
// This script patches touch event listeners to be passive for better performance

(function() {
  'use strict';
  
  // Store original addEventListener
  const originalAddEventListener = EventTarget.prototype.addEventListener;
  
  // Override addEventListener to make touch events passive
  EventTarget.prototype.addEventListener = function(type, listener, options) {
    // Guard clause: ensure this is a valid EventTarget
    if (!this || typeof this.addEventListener !== 'function') {
      return;
    }
    
    // Check if this is a touch event that should be passive
    if (type === 'touchstart' || type === 'touchmove' || type === 'touchend' || type === 'touchcancel') {
      // If options is a boolean (useCapture), convert to object
      if (typeof options === 'boolean') {
        options = { capture: options, passive: true };
      } else if (typeof options === 'object' && options !== null) {
        // If options is an object, ensure passive is true
        options.passive = true;
      } else {
        // If options is undefined/null, set passive to true
        options = { passive: true };
      }
    }
    
    // Call original addEventListener with modified options
    return originalAddEventListener.call(this, type, listener, options);
  };
  
  // Also patch jQuery's event handling if jQuery is available
  if (typeof jQuery !== 'undefined') {
    const originalJQueryOn = jQuery.fn.on;
    jQuery.fn.on = function(events, selector, data, handler) {
      // Handle different jQuery.on() signatures
      if (typeof selector === 'function') {
        handler = selector;
        selector = undefined;
        data = undefined;
      } else if (typeof data === 'function') {
        handler = data;
        data = undefined;
      }
      
      // If this is a touch event, add passive option
      if (events && (events.includes('touchstart') || events.includes('touchmove') || events.includes('touchend'))) {
        // For jQuery, we need to handle this differently
        // jQuery doesn't directly support passive events, so we'll use native addEventListener
        return this.each(function() {
          if (this && this.addEventListener) {
            const eventTypes = events.split(' ');
            const element = this; // Store element context
            eventTypes.forEach(function(eventType) {
              if (eventType.includes('touch')) {
                element.addEventListener(eventType, handler, { passive: true });
              }
            });
          }
        });
      }
      
      // For non-touch events, use original jQuery method
      return originalJQueryOn.call(this, events, selector, data, handler);
    };
  }
})();
